export default {
  name: 'informations_manual_domiciliation_bic',
  component_path: 'modules/procedures/blocks/BlockInputText'
}